export const OPTIMISTIC_ID_PREFIX = '-optimistic';
export const OPTIMISTIC_ISSUE_ID = -1;
export const ROOT_LEVEL = 'rootLevel';
export const GROUP_ITEM_PREFIX = 'GROUP_BY';
